module.exports = __webpack_public_path__ + "img/almoxarifado_estoque.2a469be1.png";